import { lazy } from "react";

export const menuRoute = {
  path: "/menu",
  exact: true,
  component: lazy(() => import("./index")),
};
